import { render } from "./UserPopover.vue?vue&type=template&id=4d048ad4&scoped=true"
import script from "./UserPopover.vue?vue&type=script&lang=js"
export * from "./UserPopover.vue?vue&type=script&lang=js"

import "./UserPopover.vue?vue&type=style&index=0&id=4d048ad4&scoped=true&lang=css"

import exportComponent from "/home/ben/work/acon/acon-360/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4d048ad4"]])

export default __exports__